import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { JiraUserCreationSuccessComponent } from './jira-user-creation-success/jira-user-creation-success.component';
import { JiraUserService } from './service/jira-user.service';

@Component({
    selector: 'apc-jira-users',
    templateUrl: './jira-users.component.html',
    styleUrls: ['./jira-users.component.scss'],
    providers: [JiraUserService],
    standalone: false
})
export class JiraUsersComponent implements OnInit {
  @Input() modalRef: any;
  jiraUsersSuccessRef: any;
  quickSearch = new Subject<any>();
  queryString: string = '';
  searchValue: string = '';
  result: any = '';
  isLoading: boolean = false;
  userSelected: boolean = false;
  integrated: boolean | undefined = undefined;
  public form: UntypedFormGroup;
  jiraGroups;
  userEmail: string;
  searchOption:boolean = false;

  constructor(private readonly jiraService: JiraUserService, public modalService: NgbModal) {
    this.initSingleForm();
    this.quickSearch.pipe(debounceTime(1000), distinctUntilChanged()).subscribe((input) => {
      this.search(input.value);
    });
  }

  ngOnInit(): void {
    this.jiraService.getUserGroupMembership().then((res) => {
      this.jiraGroups = res;
      this.jiraGroups.forEach(item => {
        item.default = true;
        item.descString = '';
        if(item.name) {
          item.descString += item.name;
        }
        if(item.features && item.features.length > 0) {
          if(item.descString.length > 0) {
            item.descString += '<br/>';
          }
          item.descString += "Related groups: "
        item.features.forEach((gr, i) => {
          item.descString += gr.label;
          if(i !== item.features.length - 1) {
            item.descString += ', ';
          }
        });
      }

        // so tooltip does not show if no text
        if(item.descString.length === 0) {
          item.descString = null;
        }
      });
    });
  }

  initSingleForm() {
    this.form = new UntypedFormGroup({
      jiraUser: new UntypedFormControl(null, [Validators.required]),
    });
  }

  close() {
    this.modalRef.dismiss();
  }

  async search(value: string) {
    this.searchValue = value;
    this.queryString = this.searchValue;
    this.isLoading = true;
    this.result = [];
    this.userSelected = false;
    if ((this.queryString.length > 0 && !this.searchOption) || (this.queryString.length == 8 && this.searchOption)) {
      this.jiraService.getJiraUsers(this.queryString, this.searchOption).then(
        (res) => {
          this.result = res;
          this.isLoading = false;
        },
        (reason) => {
          this.isLoading = false;
        }
      );
    } else {
      this.result = [];
      this.isLoading = false;
    }
  }

  closeSearch() {
    this.result = [];
    this.searchValue = '';
    this.queryString = '';
    this.integrated = undefined;
    this.isLoading = false;
    this.form.reset();
  }

  selectUser(user) {
    this.form.controls.jiraUser.patchValue(user);
    this.searchValue = user.displayName + ' (' + user.userPrincipalName + ')';
    this.userEmail = user.userPrincipalName;
    this.userSelected = true;
  }

  constructDisplayName(user) {
    let employeeType = '';
    if (user.employeeType.length) {
      employeeType = user.employeeType + ' | ';
    }
    let companyName = '';
    if (user.companyName.length) {
      companyName = user.companyName + ' | ';
    }
    return '<b>' + user.displayName + '</b>' + ' (' + user.userPrincipalName + ') <br/>' + employeeType + companyName + user.department;
  }

  async activateJiraUser(jiraUser) {
    /* #703 add groups to user */
    let selectedGroups = [];
    if(this.jiraGroups && this.jiraGroups.length > 0) {
      this.jiraGroups.forEach((item) => {
        if (item.default) {
          item.features.forEach(element => {
            if (element.default) {
              if(!selectedGroups[item.name])
                selectedGroups[item.name]= [];
              selectedGroups[item.name].push(element.label);
            }
          });
        }
      });
    }

    /*  #703 add groups to user END */
    
    const results = [];
    const requests = [];

      Object.keys(selectedGroups).forEach((item) => {

        let request = this.jiraService.createUser(jiraUser.id, item, { groups: selectedGroups[item] }).toPromise()
          .then(response => {
            results.push({ user:response, email:this.userEmail, isError:false, target:item});
          })
          .catch(error => {
            results.push({ user:error,  email:this.userEmail, isError:true, target:item});
          });

          requests.push(request);
      });
      await Promise.all(requests);

      this.close();
      this.jiraUsersSuccessRef = this.modalService.open(JiraUserCreationSuccessComponent, {
        ariaLabelledBy: 'modal-basic',
        backdrop: 'static',
        keyboard: false,
        windowClass: 'jira-users-modal',
        backdropClass: 'jira-users-backdrop',
      });
      this.jiraUsersSuccessRef.componentInstance.modalRef = this.jiraUsersSuccessRef;
      this.jiraUsersSuccessRef.componentInstance.data = results;
  }

  hideMainModal() {
    document.getElementsByClassName('jira-users-modal')[0].setAttribute('style', 'display: none !important');
  }
}
